export default "__VITE_ASSET__BC2bnk$l__"